import axios from 'axios';
import { TraceHistory } from 'types';

export async function getTracesAroundLogItem(
  alarmLogItemId: number,
  numBefore: number,
  numAfter: number
): Promise<TraceHistory[]> {
  const url = `/api/snapshot-alarm-log/items/${alarmLogItemId}/history`;
  const query = {
    params: {
      numBefore,
      numAfter,
    },
  };

  try {
    const { data } = await axios.get(url, query);
    return data as TraceHistory[];
  } catch (err) {
    throw err;
  }
}
